<template>
  <div class="notification-menu-margin menu">
    <div class="scrolling menu"
         id="notifications-menu"
         v-if="$auth.user().notifications.length">
      <div class="item"
           v-for="(notification, index) in $auth.user().notifications"
           v-if="index <= 10"
           style="min-width: 40ch !important"
           @click="goToTarget(notification)">
        <div class="ui grid">
          <div class="three wide column">
            <img class="ui avatar image"
                 src="~@/assets/image.png"
                 style="width: 2.35rem !important"
                 v-if="checkUser(notification.notifier_id)">
            <img class="ui avatar image"
                 :src="getUserImage(getUser(notification.notifier_id))"
                 alt=""
                 v-else>
          </div>
          <div class="thirteen wide column" style="margin-left: -5% !important">
            <div class="row">
              <div class="column">
                <div class="oneline">
                    {{ notification.text }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="right aligned column" style="text-align: right !important;">
                <div class="metadata">
                  <span class="data" style="color: #cac8c6 !important;">
                    {{ getPeriod(notification) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="(index + 1 ) < $auth.user().notifications.length && index + 1 < 10 "
             class="ui fluid divider"
             style="margin-bottom: -13px !important; width: 121%; margin-left: -16px !important;"></div>
      </div>
    </div>
    <div class="item" v-else>
      {{ $t('thereAreNoNotificationsYet') }}
    </div>
    <div class="ui divider" style="margin: 0px !important;"></div>
    <div class="ui blue button item"
         style="background-color: #092442 !important; color:white !important;"
         @click="navigateTo('User_Notifications')">
      {{ $t('showAllNotifications') }}
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getUser (userId) {
      if (!this.doctors || !this.employees) return
      let objects = window._.concat(this.doctors, this.employees)

      return window._.find(objects, object => {
        return object.user.id === userId
      })
    },
    getUserImage (user) {
      return user.album.images[user.album.images.length - 1].picture.url
    },
    checkUser (userId) {
      return window._.isEmpty(this.getUser(userId)) || this.getUser(userId).album.images.length < 1
    },
    getPeriod (notification) {
      let numOfMnuites = window.moment().diff(notification.created_at, 'minutes')
      if (numOfMnuites < 60) {
        return numOfMnuites + ' ' + this.$t(window.pluralize('mnuites', numOfMnuites))
      } else if (numOfMnuites < 1441) {
        let numOfHours = window.moment().diff(notification.created_at, 'hours')
        return numOfHours + ' ' + this.$t(window.pluralize('hours', numOfHours))
      } else if (numOfMnuites < 10081) {
        let numOfDays = window.moment().diff(notification.created_at, 'days')
        return numOfDays + ' ' + this.$t(window.pluralize('days', numOfDays))
      } else if (numOfMnuites < 302401) {
        let numOfWeeks = window.moment().diff(notification.created_at, 'weeks')
        return numOfWeeks + ' ' + this.$t(window.pluralize('weeks', numOfWeeks))
      } else if (numOfMnuites < 3628801) {
        let numOfMonths = window.moment().diff(notification.created_at, 'months')
        return numOfMonths + ' ' + this.$t(window.pluralize('months', numOfMonths))
      } else {
        let numOfYears = window.moment().diff(notification.created_at, 'years')
        return numOfYears + ' ' + this.$t(window.pluralize('years', numOfYears))
      }
    },
    goToTarget (notification) {
      if (notification.notifiable_type === 'User') {
        this.navigateTo(`Show_${this.getUsertype(notification.notifiable_id)}`, {
          key: 'params',
          value: { id: this.getUser(notification.notifiable_id).id }
        })
      } else if (notification.notifiable_type === 'Reservation') {
        this.navigateTo('Show_Reservation', { key: 'params', value: { id: notification.notifiable_id } })
      } else if (notification.notifiable_type === 'Patient') {
        this.navigateTo('Show_Patient', { key: 'params', value: { id: notification.notifiable_id } })
      }
    },
    getUsertype (notifiableId) {
      return window._.find(this.doctors, doctor => {
        return doctor.user.id === notifiableId
      }) ? 'Doctor' : 'Employee'
    },
    notificationsHasBeenSeen () {
      this.$http.post(`users/${this.$auth.user().id}/seen/notification`).then(() => {
        this.$auth.fetch()
      })
    },
    isApprovalRequest (notification) {
      return notification.notifiable_type === 'Approval::Request'
    }
  }
}
</script>

<style scoped>
  #notifications-menu {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 0px !important;
  }
  .oneline {
    overflow-wrap: break-word !important;
    white-space: normal !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/navbar_components/NotificationMenu.vue